import { create as p } from "zustand";
import { devtools as c } from "zustand/middleware";
import { produce as s } from "immer";
const l = p()(
  c(
    (r, i) => ({
      maps: {},
      actions: {
        initMapStore: ({ mapId: e, fabricRef: t, fabricActions: a }) => {
          const o = i().maps;
          if (o && o[e]) {
            console.warn(
              `Map ID: ${e} already exists within the usePLMapboxFabricStore`
            );
            return;
          }
          r(
            s((n) => {
              n.maps[e] = {
                isFabricLoaded: !0,
                fabricActions: a,
                fabricRef: t,
                fabricLayersStatus: {}
              };
            }),
            !1,
            `initMapStore - ${e}`
          );
        },
        deleteMapStore: (e) => {
          r(
            s((t) => {
              delete t.maps[e];
            }),
            !1,
            `deleteMapStore - ${e}`
          );
        },
        isMapStoreLoaded: (e) => {
          var a;
          return !!((a = i().maps) == null ? void 0 : a[e]);
        },
        setHoverPointer: ({ mapId: e, geoLocation: t }) => {
          r(
            s((a) => {
              a.maps[e].hoverPointer = t;
            }),
            !1,
            "setHoverPointer: sets the position of the pointer at a given time"
          );
        },
        setFabricLayersStatus: ({ mapId: e, layerId: t, status: a }) => {
          r(
            s((o) => {
              o.maps[e].fabricLayersStatus[t] = a;
            }),
            !1,
            `setFabricLayersStatus - ${t}`
          );
        },
        setState: ({ mapId: e, ...t }) => {
          r(
            s((a) => {
              Object.entries(t).forEach(([o, n]) => {
                a.maps[e][o] = n;
              });
            }),
            !1,
            `setState - ${e}`
          );
        }
      }
    }),
    {
      name: "PLMapboxFabricStore",
      enabled: !!(window && window.__REDUX_DEVTOOLS_EXTENSION__),
      stateSanitizer: (r) => ({
        ...r,
        fabricRef: "refplaceholder"
      })
    }
  )
);
export {
  l as usePLMapboxFabricStore
};
//# sourceMappingURL=index.es18.js.map
